<template>
  <div class="headerTop">
    <header class="header wrap">
      <div class="topBox flex_between main">
        <!-- logo、名称、简介 -->
        <div class="flex_center navigation_ul">
          <el-dropdown trigger="click" :hide-on-click="true" placement="bottom-start" @command="handleCommand">
            <div class="sousuo_div flex_between">
              <i><img src="@/assets/img/searche.png" alt=""></i>

              <input type="text" placeholder="请输入搜索的内容" @blur="search" @keydown="bayFun" v-model="search_text" name="" id="">
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="item" v-for="(item,index) in seararr" :key="index" icon="el-icon-time">{{item}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="login_button" v-if="!hideRight"> 
          <i @click.stop="message" :class="{'unread':user.read === 0}">
            <img v-if="user&&user.image" :src="user.image" alt="">
            <img v-else src="@/assets/img/nweinmgn.png" alt="" />
          </i>
        </div>
      </div>
    </header>
    <!-- 提示注册弹窗 -->
    <LoginPrompt @promptFun="promptFun" ref="prompt"></LoginPrompt>
      </div>
</template>

<script>
import LoginPrompt from "@/components/assembly/LoginPrompt.vue"; //注册弹窗模块

export default {
  name: 'headerTop',
  data() {
    return {
      is_login: false,//是否显示登录
      user: {},//用户信息
      search_text: '',//搜索内容
      is_agreement: false,//用户协议
      is_privacy: false,//显示隐私
      seararr: []
    }
  },
  components: {
    LoginPrompt
  },
  props: ['hideRight'],
  watch: {
    search_text: function (eve, res) {
      if (eve == '' && eve !== res) {
        // this.search();
      }
    }
  },
  methods: {
    handleCommand(command) {
      this.search_text = command
    },
    judgeUser() {//判断用户数据
      if (!this.USER()) {
        this.$refs.prompt.popupFun();
        return false;
      }
      return true;
    },
    promptFun() {//提示弹窗回调
      this.$router.push("/m_registered");
    },
    headerFun(text) {
      this.search_text = text;
    },
    bayFun(e) {//点击回车
      if (e.which == 13) {
        this.search();
      }
    },
    getsearlist() {
      if (sessionStorage.getItem('seartext')) {
        let arr = sessionStorage.getItem('seartext').split(',')
        if (arr.length > 5) {
          this.seararr = arr.reverse().slice(0, 5)
        } else {
          this.seararr = arr.reverse()
        }
      } else {
        this.seararr = []
      }
    },
    seachtextcang(text) {
      if (sessionStorage.getItem('seartext')) {
        let arr1 = sessionStorage.getItem('seartext').split(',')
        arr1.push(text)
        sessionStorage.setItem('seartext', arr1.join())
      } else {
        let arr = []
        arr.push(text)
        sessionStorage.setItem('seartext', arr.join())
      }

    },
    search() {//跳转搜索页面
      //  
      //  this.$router.push({ path: '/m_new_search'})
      // 1为文章 2为视频，3位直播
      this.seachtextcang(this.search_text)
      if (this.$route.name == 'm_column' || this.$route.name == 'm_home') {
        this.$router.push({ path: '/m_new_search', query: { searchText: this.search_text, ffg: 1 } });
        // this.$emit('searchFun', this.search_text);
      } else if (this.$route.name == 'm_new_search') {
        this.$emit('searchFun', this.search_text);
      } else if (this.$route.name == 'm_index') {
        this.$router.push({ path: '/m_new_search', query: { searchText: this.search_text, ffg: 3 } });
      } else if (this.$route.name == 'mvedioIndex') {
        this.$router.push({ path: '/m_new_search', query: { searchText: this.search_text, ffg: 2 } });
      }
    },
    message() {//消息
      if (!this.judgeUser()) {
        return false
      }
      this.$router.push("/m_message");
    },

  },
  activated() {
    this.getsearlist()
  },
  mounted() {
    this.user = this.USER();
    this.getsearlist()
    // this.getUser();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
<style scoped>
.el-dropdown {
  width: 100%;
}
.el-dropdown-menu {
  width: 80%;
}
header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  display: flex;
  padding: 0 1.5rem;
  width: calc(100% - 3rem);
  align-items: center;
  z-index: 95;
  background: #fff;
  box-shadow: 0 0 9px rgba(71, 71, 71, 0.11);
}

html,
body {
  max-width: 100vw;
}

.visible-xs {
  width: 100vw;
  overflow: hidden;
  padding-top: 0rem;
}
.topBox {
  flex: 1;
  height: auto;
  width: 100%;
}

.navigation_ul {
  flex: 1;
}

.navigation_ul .sousuo_div {
  border: 1px solid rgba(153, 153, 153, 0.5);
  border-radius: 6vw;
  background: #f7fafc;
  height: 8vw;
  padding: 0 2vw;
}

.navigation_ul .sousuo_div > i {
  width: 1.7rem;
  height: 1.7rem;
  margin-right: 0.9rem;
}

.navigation_ul .sousuo_div > input {
  flex: 1;
  margin-right: 10px;
  font-size: 1.2rem;
  border: 0;
  height: 100%;
}

.login_button {
  cursor: pointer;
  margin-left: 15px;
}

.login_button > i {
  width: 7.73vw;
  height: 7.73vw;
  border-radius: 50%;
  position: relative;
  background: #eeeeee;
}
.login_button > i.unread::after {
  position: absolute;
  top: 0;
  right: 0;
  content: "";
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  background: #f24d5b;
}

.login_button > i > img {
  width: 7.73vw;
  border-radius: 50%;
  overflow: hidden;
}

.login_button > span {
  font-size: 16px;
  color: #333;
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/m_assembly/MinHeader.vue